import { render, staticRenderFns } from "./DatePeriodSelector.vue?vue&type=template&id=61b42df2&scoped=true&"
import script from "./DatePeriodSelector.vue?vue&type=script&lang=ts&"
export * from "./DatePeriodSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DatePeriodSelector.vue?vue&type=style&index=0&id=61b42df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b42df2",
  null
  
)

export default component.exports